var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNonProRataIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 1.66699L18.3333 18.3337",
    stroke: "#8B5CF6",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95825 2.24195C8.4671 1.65263 10.115 1.51585 11.7004 1.84832C13.2857 2.18079 14.7398 2.9681 15.8848 4.11395C17.0298 5.2598 17.816 6.71451 18.1472 8.30014C18.4785 9.88576 18.3404 11.5335 17.7499 13.0419",
    stroke: "#8B5CF6",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9001 15.8996C15.1253 16.6744 14.2055 17.289 13.1932 17.7083C12.1808 18.1276 11.0958 18.3435 10.0001 18.3435C8.90438 18.3435 7.81938 18.1276 6.80705 17.7083C5.79473 17.289 4.87491 16.6744 4.10011 15.8996C3.32531 15.1248 2.71071 14.205 2.29139 13.1927C1.87207 12.1803 1.65625 11.0953 1.65625 9.99961C1.65625 8.90388 1.87207 7.81888 2.29139 6.80655C2.71071 5.79423 3.32531 4.87441 4.10011 4.09961",
    stroke: "#8B5CF6",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonProRataIcon);
export default __webpack_public_path__ + "static/media/non-pro-rata-icon.7cc5e40ee4c755549d9104f6798be97d.svg";
export { ForwardRef as ReactComponent };